import {
	type UseMutationOptions,
	useMutation,
	useQueryClient
} from '@tanstack/react-query'
import {
	type HttpUpdateIsCoverGalleryImgProPhotos,
	httpUpdateIsCoverGalleryImgProPhotos
} from '@/features/service-vetting/http/services-vetting.http.ts'
import { errorHandler } from '@/helpers/utils'
import { QUERY_KEYS } from '@/query-client'

export const useUpdateIsCoverGalleryImgProPhoto = (
	urlParams: Omit<HttpUpdateIsCoverGalleryImgProPhotos['urlParams'], 'imgId'>,
	options?: UseMutationOptions<
		unknown,
		unknown,
		HttpUpdateIsCoverGalleryImgProPhotos['payload'] &
			Pick<HttpUpdateIsCoverGalleryImgProPhotos['urlParams'], 'imgId'>
	>
) => {
	const queryClient = useQueryClient()
	return useMutation({
		...options,
		mutationFn: (payload) =>
			httpUpdateIsCoverGalleryImgProPhotos({
				urlParams: { ...urlParams, imgId: payload.imgId },
				payload,
				params: {
					responseType: 'extended'
				}
			}),
		onError: (error, variables, onMutateResult, context) => {
			errorHandler(error)
			options?.onError?.(error, variables, onMutateResult, context)
		},
		onSuccess: (data, variables, onMutateResult, context) => {
			queryClient.cancelQueries({
				queryKey: [QUERY_KEYS.SERVICE_PRO_PHOTOS, urlParams.serviceId]
			})
			queryClient.setQueriesData(
				{
					queryKey: [
						QUERY_KEYS.SERVICE_PRO_PHOTOS,
						urlParams.serviceId
					]
				},
				data
			)
			options?.onSuccess?.(data, variables, onMutateResult, context)
		}
	})
}
